import { render, staticRenderFns } from "./hotspot.vue?vue&type=template&id=64e22eed&scoped=true&"
import script from "./hotspot.vue?vue&type=script&lang=js&"
export * from "./hotspot.vue?vue&type=script&lang=js&"
import style0 from "./hotspot.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./hotspot.vue?vue&type=style&index=1&id=64e22eed&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e22eed",
  null
  
)

export default component.exports